<template>
  <x-page :class="_.page" title="规则协议">
    <x-waterfall ref="list" :load="loadData">
      <x-empty slot="empty" message="没有规则/协议~" />
      <template #default="{ data }">
        <div :class="_.list">
          <div
            v-for="item in data"
            :key="item.id"
            :class="_.item"
            @click="handleHelpClick(item.targetUrl)"
          >
            <span :class="_.title">《{{ item.title }}》</span>
            <van-icon name="arrow"></van-icon>
          </div>
        </div>
      </template>
    </x-waterfall>

    <div :class="_.placeholder"></div>
  </x-page>
</template>

<script>
  import { apiPageConfigDecorateSearchData } from '@/api'
  import { dcb } from '@dcb/jssdk'
  export default {
    data() {
      return {
        loading: true,
      }
    },

    methods: {
      loadData({ pageNumber }) {
        return apiPageConfigDecorateSearchData({
          id: '多多商城_我的_规则/协议',
          pageIndex: pageNumber,
          pageSize: 10,
        })
      },
      handleHelpClick(targetUrl) {
        dcb.navigateTo({
          url: targetUrl,
        })
      },
    },
  }
</script>

<style lang="scss" module>
  .list {
    margin: 12px 12px 0;
    padding: 0 12px;
    background-color: white;
    border-radius: 10px;

    .item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 16px 0px;
      .title {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #333333;
        line-height: 22px;
        font-style: normal;
      }

      &:not(:last-child) {
        border-bottom: 1px solid rgba(0, 0, 0, 0.12);
      }
      :global {
        .van-icon {
          font-size: 16px;
        }
      }
    }
  }
</style>
